import DataNotFound from 'components/DataNotFound/DataNotFound';
import DistributionDonut from 'components/AiAnalytics/shared/DistributionDonut/DistributionDonut';
import { BaseWidget } from 'models/WidgetModel';
import React, { useMemo } from 'react';
import { mapChurnRiskDistributionResponse } from './churnRiskDistribution.mapper';
import './ChurnRiskDistribution.scss';

const ChurnRiskDistribution: React.FC<BaseWidget> = ({ response }) => {
  const view = useMemo(() => mapChurnRiskDistributionResponse(response), [response]);
  if (!view) return <DataNotFound />;
  if (!view.hasActivity)
    return <div className="churn-risk-distribution__no-activity">No activity</div>;
  return (
    <div className="churn-risk-distribution">
      <DistributionDonut
        segments={view.segments}
        centerValue={`${view.dominant.value}%`}
        centerLabel={view.dominant.label}
        accessibleLabel={`Churn risk distribution: ${view.segments
          .map(({ label, value }) => `${label} ${value}%`)
          .join(', ')}`}
      />
      {view.showLabels ? (
        <ul className="churn-risk-distribution__legend">
          {view.segments
            .filter((segment) => segment.value > 0)
            .map((segment) => (
              <li key={segment.id}>
                <span style={{ backgroundColor: segment.color }} aria-hidden="true" />
                {segment.label}
                <strong>{segment.value}%</strong>
              </li>
            ))}
        </ul>
      ) : null}
    </div>
  );
};
export default ChurnRiskDistribution;
